/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

interface PieChartProps {
  data: Record<string, string | number>[];
  label: string;
  series: string;
  onSliceClick?: (payload: {
    label: string;
    value: number;
    index: number;
  }) => void;
}

export default function PieChart({
  data,
  label,
  series,
  onSliceClick,
}: PieChartProps) {
  const chartSeries = useMemo(
    () => data.map((item) => Number(item[series])),
    [data, series],
  );

  const chartLabels = useMemo(
    () => data.map((item) => String(item[label])),
    [data, label],
  );

  const chartOptions: ApexCharts.ApexOptions = useMemo(
    () => ({
      labels: chartLabels,
      chart: {
        type: "pie",
        events: {
          dataPointSelection: (_e, _ctx, config) => {
            const index = config.dataPointIndex;
            if (index === -1) return;

            const payload = {
              index,
              label: chartLabels[index],
              value: chartSeries[index],
            };

            setTimeout(() => {
              onSliceClick?.(payload);
            }, 100);
          },
        },
      },
      dataLabels: { enabled: true },
      legend: { show: false },
      colors: ["#60db87", "#e65c66"],
    }),
    [chartLabels, chartSeries, onSliceClick],
  );

  return (
    <ReactApexChart
      options={chartOptions}
      series={chartSeries}
      type="pie"
      width="100%"
    />
  );
}
